module.exports = __webpack_public_path__ + "static/media/checkedSelected.16896b85.svg";